$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = LANG.aguarde;

	$.cookieBar({
		message: LANG.cookies_txt,
		acceptText: LANG.cookies_btn,
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: LANG.cp_txt,
		policyURL: LANG.cp_url,
	});

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('.loading-container').fadeOut(500, function () {
			$(this).remove();
		});
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	windowOnScroll();
	$(window).on('scroll', function () {
		// compensateRellax();
		windowOnScroll();
		// fixReleaseTabs();
	});

	if ($('.mh').length) {
		$('.mh').matchHeight(true);
	}
	$.fn.matchHeight._update();
	if ($('.opinion_slider').length) {
		$('.mh1').matchHeight(false);
	}

	/**
	 * Build menu image animation
	 */
	var menu_cards = $('#menu-cards');
	$('.nav-right').find('li').each(function(index){
		var image = $(this).data('image');
		menu_cards.append('<div class="card"><div class="img" style="background-image: url(\''+image+'\');"></div></div>');
	});

	$(".nav-right").on({
		mouseenter: function() {
			var index = $(this).parent().data('index');
			menu_cards.find('.card.active').removeClass('active');
			menu_cards.find('.card').eq(index + 1).addClass('active');
		},
		mouseleave: function() {
			menu_cards.find('.card.active').removeClass('active');
			menu_cards.find('.card:first').addClass('active');
		}
	}, "a");

		/**
	 * Abrir e fechar o menu
	 */
		 $('#toggle-menu').on('click', function () {
			var el = $(this);
			if (el.hasClass('opened')) {
				el.removeClass('opened');
				menu_cards.find('.card.active').removeClass('active');
				$('#menu').removeClass('show');
	
				$('body').removeClass('menu-opened');
				
				blockScroll(0);
			} else {
				el.addClass('opened');
				$('#menu').addClass('show');
	
				$('body').addClass('menu-opened');

				menu_cards.find('.card:first').addClass('active');
				blockScroll(1);
				// if (window.matchMedia("(max-width: 950px)").matches){
				// 	blockScroll(0);
				// }
			}
		});


	/**
	 * SMOOTH SCROLL WITHOUT ANCHOR
	 */

	
		$("[data-id]").on( 'click', function() {
			$(".sticky_title.active").removeClass("active");
			var data = $(this).attr("data-id");
			var data_id = data.replace('tance', '');
			//console.log(data_id);
			$('html, body').animate({
				scrollTop: $("#" + data_id).offset().top - 90
			}, 1000);
			console.log("#sticky-inner p."+data);
			$(".sticky_title[data-id="+data+"]").addClass("active");
			//$("#sticky-inner p.sticky_title").addClass("active");
		});

		$("#categoria").on("change", function (e) {
			e.preventDefault();
			//console.log($(this).attr("rel"));
			if (parseInt($(this).val()) > 0)
				window.location.href = $(this).attr("rel") + "?category_id=" + $(this).val();
			else
				window.location.href = $(this).attr("rel");
		});

		$('#ordenar').on("change", function () {
			var order = $(this).find('option:selected').val();
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			urlParams.delete('order');
			var newParams = urlParams.toString() != '' ? ('?' + urlParams.toString()) : '';
			var orderParams;
			if (urlParams.toString() != '' && order) {
				orderParams = '&order=' + order;
			} else if (urlParams.toString() == '' && order) {
				orderParams = '?order=' + order;
			} else {
				orderParams = '';
			}
			window.location.href = CURRENT_URL + newParams + orderParams;
		});

	/**
	 * Fade loading images
	 */
	/*var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}*/

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
        /**
         * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
         */
        init: (elements) => {
            let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function() {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function() {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					}else{//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
        }
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	/**
	 * Exemplo de submissão de form
	 */
	$('body').on('click', '#send-suggestion', function (e) {
		e.preventDefault();

		var form = $('form.suggestion-form');
		var fields = form.serialize();
		var action = form.attr('action');

		if (checkPolicy(form)) {
			var send = true;
			form.find('#feedback__suggestion').removeClass().html('');
			form.find('.invalid').removeClass('invalid');

			if ($('#email').length) {
				var email = $('#email').val();
				if (!IsEmail(email)) {
					form.find('#email').parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.email_invalido).addClass('error').fadeIn("fast");
					send = false;
				}
			}

			var required = form.find('.required');
			required.each(function () {
				if ($.trim($(this).val()) == '' || $.trim($(this).val()) == $(this)[0].defaultValue) {
					$(this).parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.preencha_os_campos_em_falta).addClass('error').fadeIn("fast");
					send = false;
				}
			});
			if (send) {
				$.blockUI();
				$.ajax({
					url: action,
					type: 'POST',
					data: fields,
					dataType: 'json',
					success: function (r) {
						if (r.class == 'ok') {
							form[0].reset();
						}
						$('#feedback__suggestion').show().addClass(r.class).html(r.message);
						$.unblockUI();
					},
					error: function (r) {
						$('#feedback__suggestion').show().addClass('error').html(LANG.email_erro);
						$.unblockUI();
					}
				});
			}
		} else {
			$('#feedback__suggestion').show().addClass('error').html(LANG.accept_privacy_policy);
			$.unblockUI();
		}
		
	});

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}
	var swiper = new Swiper(".hp-slider", {
		slidesPerView: "auto",
		spaceBetween: 30,
		navigation: {
			prevEl: ".hp-swiper-button-prev",
			nextEl: ".hp-swiper-button-next",
		},
		breakpoints: {
			// when window width is >= 320px
			569: {
				spaceBetween: 60
			},
		}
	});

	var swiper = new Swiper(".aldeia_viva_slider", {
		preventClicksPropagation: true,
		slidesPerView: "auto",
		//roundLengths: true,
		//rewind: true,
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
          	hide: false,
		},
		
		// mousewheel: {
		// 	invert: false,
		// 	forceToAxis: true
		//   },
		breakpoints: {
			// when window width is >= 320px
			1200: {
				slidesPerView: "auto",
				spaceBetween: 30
			},
			950: {
				slidesPerView: "auto",
				spaceBetween: 60
			},
		}
	});
	var swiper = new Swiper(".produto_slider", {
		slidesPerView: 1,
		roundLengths: true,
		setWrapperSize: true,
		rewind: true,
		 navigation: {
		 	prevEl: ".produto-slider-swiper-button-prev",
		 	nextEl: ".produto-slider-swiper-button-next",
		 },
		breakpoints: {
			// when window width is >= 320px
			
		}
	});
	$(".onde_single_slider").each(function (index, element) {
		var $this = $(this);
		var swiper = new Swiper(".instance-" + index, {
			slidesPerView: 1,
			roundLengths: true,
			setWrapperSize: true,
			rewind: true,
			// spaceBetween: 60,
			
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			},
			// mousewheel: {
			// 	invert: true,
			// 	forceToAxis: true
			//   },
			breakpoints: {
				// 569: {
				// 	slidesPerView: 2.5,
				// 	spaceBetween: 30
				// },
				// 1366: {
				// 	slidesPerView: 2.5,
				// 	spaceBetween: 40
				// },
				// 1920: {
				// 	slidesPerView: 2.5,
				// 	spaceBetween: 60
				// },
			}
		});
	});

	$(".opinion_slider").each(function (index, element) {
		// var $this = $(this);
		//console.log(index)
		var swiper = new Swiper(".ins-" + index  ,  {
			slidesPerView: "auto",
   			//slidesPerGroup: 0.5,
			rewind: false,
			setWrapperSize: true,
			autoplay: false,
			//cssWidthAndHeight: 'auto',
			//watchSlidesProgress: true,
			draggable: true,
			scrollbar: {
				el: ".scrollbar-" + index  ,
				draggable: true,
				//hide: false,
			},
			navigation: true,
			
				breakpoints: {
					1200: {
						slidesPerView: "auto",
						spaceBetween: 30
					},
					950: {
						slidesPerView: "auto",
						spaceBetween: 30
					},
					450: {
						slidesPerView: "auto",
						spaceBetween: 30
				   },
			}
		});
		swiper.update();
		swiper.updateSlides()
		//preventDefault();
		//e.preventDefault();
		//console.log(swiper)
	});

	var sticky = $('#sticky');
	var sidebar;
	if(sticky.length && window_w > window_h){
  
		sidebar = new StickySidebar('#sidebar', {
			topSpacing: 100,
			bottomSpacing: 0,
			containerSelector: '#sticky-container',
			innerWrapperSelector: '#sticky-inner'
		});
		
		var target = document.querySelector('#content');
  
		// create an observer instance
		var observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				if(mutation.type == 'childList'){
					sidebar.updateSticky();
				}
			});    
		});
  
		// pass in the target node, as well as the observer options
		observer.observe(target, { attributes: true, childList: true, subtree: true });
	}

	let container = document.querySelector(".h-scroller-container");
if(container && window.matchMedia("(min-width: 1180px)").matches && !Modernizr.touchevents){
	console.log("no-touch")
	gsap.to(container, {
		x: () =>
		-(container.scrollWidth - document.documentElement.clientWidth) + "px",
	  ease: "none",
	  scrollTrigger: {
		trigger: container,
		start: "top top",
		invalidateOnRefresh: true,
		pin: true,
		scrub: 1,
		pinSpacing: true,
		end: () => "+=" + container.offsetWidth
	}
});


gsap.to('.h-scroller-progress-bar', {
	scaleX: 1,
	ease: 'none',
	scrollTrigger: { scrub: 1 }
});
}
let container1 = document.querySelector(".map");
if (container1 && window.matchMedia("(min-width: 1365px)").matches && document.querySelector(".tippy")) {
  /* a viewport tem pelo menos 400 pixels de largura */
  tippy('.tippy', {
	/* hideOnClick: false,
	trigger: 'click' */
});
} else {
  /* a viewport menos que 400 pixels de largura */
  //console.log(window.matchMedia("(min-width: 1665px)").matches);
}
// if($('.tippy').length){
// 	tippy('.tippy', {
// 		/* hideOnClick: false,
// 		trigger: 'click' */
// 	});
// }	



});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

	/**
 * Window on scroll
 */
	 function windowOnScroll() {
		
	   if ($(window).scrollTop() > 45 && !$('body').hasClass('scrolled')) {
		   $('body').addClass('scrolled');
	   } else if ($(window).scrollTop() <= 45 && $('body').hasClass('scrolled')) {
		   $('body').removeClass('scrolled');
	   }
	//    if (window.matchMedia("(max-width: 950px)").matches && $(window).scrollTop() > 25 && !$('body').hasClass('scrolled')) {
	// 		$('body').addClass('scrolled');
	//   } else if (window.matchMedia("(max-width: 950px)").matches && $(window).scrollTop() <= 25 && $('body').hasClass('scrolled')) {
	// 	$('body').removeClass('scrolled');
	// }
   }